import { curry, defaultTo, keys, pick, pipe, prop } from "ramda";

type FieldsTuple = [string, Array<string>];

const getFieldsFromTuple = (tuple: FieldsTuple) =>
  pipe(prop(tuple[0]), defaultTo({}), pick([...tuple[1]]));

const getKeys = (data: Record<string, unknown>) => keys(data);

const getFieldKeys = (
  tuple: FieldsTuple
): ((arg: Record<string, unknown>) => Array<string>) =>
  pipe(getFieldsFromTuple(tuple), getKeys);

const subtractFieldsFromObject = (
  tuple: FieldsTuple,
  firstObj: Array<string>,
  secondObj: Array<string>
) =>
  getFieldsFromTuple([
    tuple[0],
    [...firstObj.filter((field) => !secondObj.includes(field))],
  ]);

const curriedSubtractFieldsFromObject = (
  firstObj: Record<string, unknown>,
  secondObj: Record<string, unknown>,
  tuple: FieldsTuple
): Record<string, unknown> =>
  curry(
    subtractFieldsFromObject(
      tuple,
      getFieldKeys(tuple)(firstObj),
      getFieldKeys(tuple)(secondObj)
    )
  )(firstObj);

export { curriedSubtractFieldsFromObject as subtractFieldsFromObject };
